import { lazy } from 'react';

const DatePicker = lazy(() => import('./DatePicker'));

export { DatePicker };
